import { observer } from 'mobx-react-lite'

import { Icon } from '@mxenabled/mx-icons'
import { Text } from '@mxenabled/mxui'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useGlobalCopyStore } from '../../common'

interface NotificationEmptyStateProps {
  onManageNotifications: () => void
}

export const NotificationEmptyState = observer(
  ({ onManageNotifications }: NotificationEmptyStateProps) => {
    const { notifications: notificationsCopy } = useGlobalCopyStore()

    return (
      <Stack sx={{ alignItems: 'center', height: '95%', justifyContent: 'center' }}>
        <Icon name="notifications" size={32} />

        <Text sx={{ pt: 32 }} variant="h3">
          {notificationsCopy.notification_empty_state.no_new_notifications}
        </Text>
        <Text
          sx={{
            maxWidth: 327,
            pb: 24,
            pt: 12,
            textAlign: 'center',
          }}
          variant="subtitle1"
        >
          {notificationsCopy.notification_empty_state.notification_description}
        </Text>
        <Button onClick={onManageNotifications} sx={{ p: '12px 16px' }} variant="outlined">
          {notificationsCopy.notification_empty_state.manage_notifications}
        </Button>
      </Stack>
    )
  },
)
